import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Roles } from '../../../commonType';
import { releaseHoldReservation } from '../../../features/offerAvailability/offerAvailabilityService';
import { setLoadingStatus } from '../../../features/offerAvailability/offerAvailabilitySlice';
import { ReleaseHoldPropertyRequest } from '../../../features/offerAvailability/types';
import { RootState } from '../../../redux/rootReducer';
import { clearStorage, getLoggedinUserFullName, getLoggedinUserName } from '../../../util';
import withLocalization from '../../hoc/withLocalization';
import withRoles from '../../hoc/withRoles';
import { NavigationSteps } from '../../OfferDetails/OfferNavigation';
import ParseHtml from '../ParseHtml';
import './Header.scss';

interface HeaderProps {
  localize?: any;
  userRole?: Roles;
}

const Header: FC<any> = (props: HeaderProps): ReactElement => {
  const { localize, userRole } = props;
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const holdSessionId = useSelector((state: RootState) => state.availabilityDates.holdSessionId);
  const currentStep = useSelector((state: RootState) => state.offerDetails.currentNavigationStep);
  const currentRole = userRole === Roles.Field_Associate ? 'FA' : 'CA';
  const renderReset =
    currentStep !== NavigationSteps.OFFER_SEARCH && currentStep !== NavigationSteps.OFFER_CONFIRMATION;

  const VERSION = 'FA-0.0.1.23';
  const handleReset = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleClear = async () => {
    if (holdSessionId) {
      const releaseRequest: ReleaseHoldPropertyRequest = {
        holdId: holdSessionId,
      };
      dispatch(setLoadingStatus(true));
      await releaseHoldReservation(releaseRequest);
    }
    clearStorage();
    window.location.href = '/';
  };
  useEffect(() => {
    sessionStorage.setItem('app_version', VERSION);
  }, [VERSION]);
  const userName = getLoggedinUserFullName ?? getLoggedinUserName();
  const welcomeMessage = userName
    ? `${localize(
        'preview-sales-engine.static-content.copy.Labels.labels#header-welcome-message',
        userName,
      )}(${currentRole})`
    : '';
  return (
    <React.Fragment>
      <header className="row">
        <div className="container">
          <div className="sticky-wrapper sticky">
            <div className="header sticky-inner">
              <a href="/">
                <img
                  className=""
                  src="https://marriottvacationsworldwide.com/common/cms/mvc/images/logo/mvc_horizontal-2x.png"
                  alt="Marriott Vacation Club Logo"
                />
              </a>
              <div className="button align-right">
                {renderReset ? (
                  <button className="btn btn-primary" onClick={handleReset}>
                    {localize('preview-sales-engine.static-content.copy.header.reset')}
                  </button>
                ) : (
                  <></>
                )}
                <br></br>
                <span>
                  <i>{welcomeMessage}</i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Modal
        dialogClassName="modal-custom-reset"
        show={show}
        backdrop="static"
        keyboard="false"
        scrollable={true}
        animation={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <ParseHtml htmlInput={localize('preview-sales-engine.static-content.copy.header.cancel-modal-copy')} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClear}>
            {localize('preview-sales-engine.static-content.copy.header.cancel-modal-button-yes')}
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            {localize('preview-sales-engine.static-content.copy.header.cancel-modal-button-no')}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
export default React.memo(withLocalization(withRoles(Header)));
